import { Injectable } from '@angular/core';
import { SysidnameServicePkg } from './sysidnamePkg.service';

@Injectable({
  providedIn: 'root',
})
export class SysidnameService extends SysidnameServicePkg {
  constructor() {
    super();
  }
}
